// components/modals/SuccessModal.js
import React, { useState } from 'react';
import Modal from "react-bootstrap/Modal";
import { formatAddress } from '../../../helper';
import { Link } from 'react-router-dom';
import { EXPLORER_URL } from '../../../utils/constant';

const SuccessModal = ({ show, onClose, formData, trxHash, apiRes, tokenSymbol }) => {
    const [copied, setCopied] = useState(false);

    const poolLink = `${window.location.origin}/activepools/${apiRes?.contractAddress}`;

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(poolLink);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // reset after 2 seconds
        } catch (err) {
            console.error("Failed to copy: ", err);
        }
    };

    return (
        <Modal className="success" show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Success</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="innercontentmodal">
                    <div className="upperheading">
                        <img src="\assets\tick.svg" alt="success" />
                        <h2>{formData.projectName} Root Pool Created!</h2>
                        <p>
                            You've staked <span>{formData.totalRewards} {tokenSymbol} </span>and launched the
                            project's core rewards hub.
                        </p>
                    </div>

                    <div className="tokenbox">
                        <div className="parenttoken">
                            <div className="left">
                                <h2>Reward Token</h2>
                            </div>
                            <div className="right">
                                <p>{formData.rewardToken.slice(0, 10)}...{formData.rewardToken.slice(-6)}</p>
                                <button>
                                    {tokenSymbol}
                                </button>
                            </div>
                        </div>

                        <div className="parenttoken">
                            <div className="left">
                                <h2>Total Rewards</h2>
                            </div>
                            <div className="right">
                                <p>{formData.totalRewards}</p>
                                <img
                                    style={{ width: '14px', height: '14px', borderRadius: '50%' }}
                                    src={formData.logoPreview ? formData.logoPreview : "\assets\img.png"}
                                    alt="img"
                                    className="img-fluid"
                                />
                            </div>
                        </div>

                        <div className="parenttoken">
                            <div className="left">
                                <h2>Pool End Date & Time</h2>
                            </div>
                            <div className="right">
                                <p>{formData.poolEndDate?.toLocaleString()}</p>
                            </div>
                        </div>

                        <div className="parenttoken">
                            <div className="left">
                                <h2>Transaction Hash</h2>
                            </div>
                            <div className="right">
                                <p>{formatAddress(trxHash)}</p>
                                <a
                                    href={`${EXPLORER_URL}${trxHash}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src="/assets/trxHashImg.svg" alt="Transaction link" />
                                </a>
                            </div>
                        </div>

                        <div className="parenttoken forbacknew">
                            <div className="left">
                                <h2>Status:</h2>
                            </div>
                            <div className="right">
                                <p>Emissions scheduled & Child Pools can now be created</p>
                            </div>
                        </div>
                    </div>

                    <div className="sharepoolbox">
                        <div className="leftshare">
                            <p>Share Pool Link</p>
                            <h6>{formatAddress(poolLink) }</h6>
                        </div>
                        <div className="rightshare">
                            <button onClick={handleCopy}>
                                {copied ||  <img src="/assets/copy.svg" alt="" />}
                                {copied ? "Copied!" : "Copy"}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="lastbutton">
                    <button className="close" onClick={onClose}>Close</button>
                    <Link
                        className="view"
                        to={`/activepools/${apiRes?.contractAddress}`}
                    >
                        View Pool Page
                    </Link>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default SuccessModal;
